import { defineMessages } from 'react-intl';

const messages = defineMessages({
  header: {
    id: 'collegeevents.header',
    defaultMessage: 'College Events',
  },
  eventdate: {
    id: 'collegeevents.eventdate',
    defaultMessage: 'Event Date',
  },
  collegename: {
    id: 'collegeevents.collegename',
    defaultMessage: 'College Name',
  },
  eventlocation: {
    id: 'collegeevents.eventlocation',
    defaultMessage: 'Event Location',
  },
  recommended: {
    id: 'collegeevents.row.recommended',
    defaultMessage: 'Recommended for you',
  },
  recommendedMobile: {
    id: 'collegeevents.row.recommended',
    defaultMessage: 'Recommended',
  },
  signup: {
    id: 'collegeevents.row.signup',
    defaultMessage: 'SIGN UP',
  },
  moredetails: {
    id: 'collegeevents.row.moredetails',
    defaultMessage: 'View more details',
  },
  fewerdetails: {
    id: 'collegeevents.row.fewerdetails',
    defaultMessage: 'View fewer details',
  },
  nodetails: {
    id: 'collegeevents.row.nodetails',
    defaultMessage: 'No additional details available',
  },
  seerecommendedevents: {
    id: 'collegeevents.see.recommended.events',
    defaultMessage: 'See recommended events!',
  },
  paginationHint: {
    id: 'collegeevents.pagination.hint',
    defaultMessage: 'Showing {0} of {1} results',
  },
  paginationButton: {
    id: 'collegeevents.pagination.button',
    defaultMessage: 'Show More',
  },
  noevents: {
    id: 'collegeevents.noevents',
    defaultMessage: 'Sorry! There are currently no events scheduled that meet your search criteria.',
  },
  viewallevents: {
    id: 'collegeevents.viewallevents',
    defaultMessage: 'View all events',
  },
  virtualEvent: {
    id: 'collegeevents.virtualEvent',
    defaultMessage: 'Virtual Event',
  },
  coppaBlockText: {
    id: 'collegeevents.coppaBlockText',
    defaultMessage: `It looks like you won't be able to sign up for this event through Naviance because there is a COPPA block on your account.`,
  },
  ferpaBlockText: {
    id: 'collegeevents.ferpaBlockText',
    defaultMessage: `It looks like you won't be able to sign up for this event through Naviance because there is a FERPA block on your account.`,
  },
  coppaFerpaBlockHint: {
    id: 'collegeevents.coppaFerpaBlockText',
    defaultMessage: 'Please contact your counselor for assistance.',
  },
});

export default messages;
